import { render, staticRenderFns } from "./LeftImage.vue?vue&type=template&id=b5c8c870&"
import script from "./LeftImage.vue?vue&type=script&lang=js&"
export * from "./LeftImage.vue?vue&type=script&lang=js&"
import style0 from "./LeftImage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports